<template>
  <div>
    <preloader v-if="this.loading" />
    <div v-else>
      <system-bar />
      <TheAppBar :color="color" :flat="flat" />
      <TheHero />
      <v-main class="pa-0">
        <vue-page-transition name="flip-y">
          <router-view />
        </vue-page-transition>
      </v-main>
      <TheFooter />
      <btn-whatsapp v-show="fab" v-scroll="onScroll" />
    </div>
  </div>
</template>

<script>
import Preloader from "../components/Preloader.vue";

export default {
  name: "Layout-Landing",

  components: {
    SystemBar: () => import("@/components/TheSystemBar"),
    TheAppBar: () => import("@/components/TheAppBar"),
    TheHero: () => import("@/components/TheHero"),
    TheFooter: () => import("@/components/TheFooter"),
    // BtnBackToTop: () => import("@/components/BtnBackToTop"),
    BtnWhatsapp: () => import("@/components/BtnWhatsapp"),
    Preloader
  },

  data: () => ({
    fab: null,
    color: "grey lighten-5",
    flat: true,
    loading: true
  }),
  created() {
    const top = window.pageYOffset || 0;
    if (top <= 20) {
      //this.color = "white"; //transparent
      this.flat = true;
    }
  },
  watch: {
    fab(value) {
      if (value) {
        //this.color = "white";
        this.flat = false;
      } else {
        //this.color = "white"; //transparent
        this.flat = true;
      }
    }
  },
  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    showToggle() {
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    }
  },
  mounted() {
    if (this.loading) this.showToggle();
  }
};
</script>
<style lang="sass">
.extra-padding
  padding-bottom: 76px !important
  padding-top: 46px !important
  @media screen and (max-width: 959px)
    padding-top: 38px !important
    padding-bottom: 38px !important
</style>
